var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-prev",class:{ 'no-count': _vm.noCount }},[_c('button',{domProps:{"innerHTML":_vm._s(_vm.$icon('prev'))},on:{"click":function($event){$event.preventDefault();return _vm.prev($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }